// If user don't have company then it is END-USER
export const checkIsProfessionalUser = company => {
  return !!company;
};
